import { defineMessages } from 'react-intl';

export default defineMessages({
    accountHolder: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Account Holder.Title',
        defaultMessage: 'Account Holder'
    },
    additionalInsured: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Additional Insured.Title',
        defaultMessage: 'Additional Insured Types'
    },
    additionalInterest: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Additional Interest.Title',
        defaultMessage: 'Additional Interest'
    },
    detail: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Additional Interest.Detail.Title',
        defaultMessage: 'Additional Interest Details: {subtype}'
    },
    additionalInterestCertificateRequired: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Additional Interest.Detail.Certificate Required',
        defaultMessage: 'Certificate Required'
    },
    additionalInteresContractNumber: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Additional Interest.Detail.Contract Number',
        defaultMessage: 'Contract Number'
    },
    additionalInterestInterest: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Additional Interest.Detail.Interest',
        defaultMessage: 'Interest'
    },
    additionalInterestType: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Additional Interest.Detail.Type',
        defaultMessage: 'Type'
    },
    namedInsured: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Named Insured.Title',
        defaultMessage: 'Named Insured'
    },
    namedInsuredIndustryCode: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Named Insured.Industry Code',
        defaultMessage: 'Industry Code'
    },
    namedInsuredIndustryCodeClassification: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Named Insured.Industry Code Classification',
        defaultMessage: 'Classification'
    },
    namedInsuredOrganizationType: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Named Insured.Organization Type',
        defaultMessage: 'Organization Type'
    },
    namedInsuredBusOpDescription: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Named Insured.Business Operation Description',
        defaultMessage: 'Business Operation Description'
    },
    driver: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Title',
        defaultMessage: 'Driver'
    },
    driverAccountAccidents: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Account.Accidents',
        defaultMessage: 'Account Level : Number of Accidents'
    },
    driverPolicyLevelNumberOfAccidents: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Policy.Accidents',
        defaultMessage: 'Policy Level : Number of Accidents'
    },
    driverAccountViolations: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Account.Violations',
        defaultMessage: 'Account Level : Number of Violations'
    },
    driverPolicyLevelNumberOfViolations: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Policy.Violations',
        defaultMessage: 'Policy Level : Number of Violations'
    },
    driverLicenseNumber: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.License Number',
        defaultMessage: 'License Number'
    },
    driverLicenseState: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.License State',
        defaultMessage: 'License State'
    },
    driverYearLicensed: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Year Licensed',
        defaultMessage: 'Year First Licensed'
    },
    driverDateCompletedTrainingClass: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Date Completed Training Class',
        defaultMessage: 'Date Completed Training Class'
    },
    driverTrainingClassType: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Training Class Type',
        defaultMessage: 'Training Class Type'
    },
    driverGoodStudent: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Good Student',
        defaultMessage: 'Good Student'
    },
    driverExcluded: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Excluded',
        defaultMessage: 'Excluded?'
    },
    driverApplicableGoodDriverDiscount: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Apply Good Driver Discount',
        defaultMessage: 'Apply Good Driver Discount?'
    },
    driverGoodDriverDiscount: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Qualifies Driver Discount',
        defaultMessage: 'Qualifies for a Good Driver Discount'
    },
    yes: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.Yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Driver.No',
        defaultMessage: 'No'
    },
    laborClient: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.Title',
        defaultMessage: 'WC Labor Client'
    },
    laborClientDetail: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.Detail',
        defaultMessage: 'WC Labor Client Detail: {description}'
    },
    laborClientContractEffectiveDate: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.Contract Effective Date',
        defaultMessage: 'Contract Effective Date'
    },
    laborClientContractExpirationDate: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.Contract Expiration Date',
        defaultMessage: 'Contract Expiration Date'
    },
    laborClientEmployees: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.Employees',
        defaultMessage: 'Number of Employees'
    },
    laborClientInclusion: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.Inclusion',
        defaultMessage: 'Inclusion'
    },
    laborClientLocation: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.Location',
        defaultMessage: 'Work Location'
    },
    laborClientState: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Client.State',
        defaultMessage: 'State'
    },
    laborContractor: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.Title',
        defaultMessage: 'WC Labor Contractor'
    },
    laborContractorDetail: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.Detail',
        defaultMessage: 'WC Labor Contractor Detail: {description}'
    },
    laborContractorContractEffectiveDate: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.Contract Effective Date',
        defaultMessage: 'Contract Effective Date'
    },
    laborContractorContractExpirationDate: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.Contract Expiration Date',
        defaultMessage: 'Contract Expiration Date'
    },
    laborContractorEmployees: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.Employees',
        defaultMessage: 'Number of Employees'
    },
    laborContractorInclusion: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.Inclusion',
        defaultMessage: 'Inclusion'
    },
    laborContractorLocation: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.Location',
        defaultMessage: 'Work Location'
    },
    laborContractorState: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Labor Contractor.State',
        defaultMessage: 'State'
    },
    ownerOfficer: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Owner Officer.Title',
        defaultMessage: 'Owner/Officer'
    },
    ownerOfficerClassCode: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Owner Officer.Class Code',
        defaultMessage: 'Class Code'
    },
    ownerOfficerInclusion: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Owner Officer.Inclusion',
        defaultMessage: 'Inclusion'
    },
    ownerOfficerOwnershipPercentage: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Owner Officer.Ownership Percentage',
        defaultMessage: 'Ownership Percentage'
    },
    ownerOfficerPolicyRelationship: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Owner Officer.Policy Relationship',
        defaultMessage: 'Policy Relationship'
    },
    ownerOfficerRelationshipTitle: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Owner Officer.Relationship Title',
        defaultMessage: 'Title/Relationship'
    },
    ownerOfficerState: {
        id: 'e1p.gateway.contacts.components.ContactDetails.Roles.Owner Officer.State',
        defaultMessage: 'State'
    },
    claimsInfoContact: {
        id: 'e1p.gateway.contacts.common.views.roles.ClaimsInfoContact',
        defaultMessage: 'Claims Info Contact'
    },
    billingContact: {
        id: 'e1p.gateway.contacts.common.views.roles.BillingContact',
        defaultMessage: 'Billing Contact'
    },
    accountingContact: {
        id: 'e1p.gateway.contacts.common.views.roles.AccountingContact',
        defaultMessage: 'Accounting Contact'
    },
    inspectionContact: {
        id: 'e1p.gateway.contacts.common.views.roles.InspectionContact',
        defaultMessage: 'Inspection Contact'
    },
    secondaryContact: {
        id: 'e1p.gateway.contacts.common.views.roles.SecondaryContact',
        defaultMessage: 'Secondary Contact'
    },
});
